import * as React from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

import { snakeToPascal } from '../../utils/caseconverters';

const Wysiwyg = dynamic(() => import('../Wysiwyg'));
const WideImage = dynamic(() => import('../WideImage'));
const Fact = dynamic(() => import('../Fact'));
const MediaCluster = dynamic(() => import('../MediaCluster'));
const ResultBallsSmall = dynamic(() => import('../ResultBallsSmall'));
const BrandBalls = dynamic(() => import('../BrandBalls'));
const GifCard = dynamic(() => import('../GifCard'));
const CardTextCta = dynamic(() => import('../CardTextCta'));
const PromoVideos = dynamic(() => import('../PromoVideos'));
const WideVideo = dynamic(() => import('../WideVideo'));
const Quote = dynamic(() => import('../Quote'));
const ImageGallery = dynamic(() => import('../ImageGallery'));
const LinkList = dynamic(() => import('../LinkList'));
const AlignedText = dynamic(() => import('../AlignedText'));
const QuotesWithImage = dynamic(() => import('../QuotesWithImage'));
const StatisticsText = dynamic(() => import('../StatisticsText'));
const UniqueSellingPoints = dynamic(() => import('../UniqueSellingPoints'));
const CardOffer = dynamic(() => import('../CardOffer'));
const FloatingBrandBalls = dynamic(() => import('../FloatingBrandBalls'));

// Due to a error in the chunk css-extract-plugin when dealing with dynamic
// imports we load certain component using es6 imports, the error is:
// 'Cannot read property 'pop' of undefined'
import SmallVideo from '../SmallVideo';
import Billboard from '../Billboard';

import s from './Streamfield.module.scss';

export interface StreamfieldProps {
    items: any[];
    pageType?: string;
}

const Components = {
    Wysiwyg: Wysiwyg,
    WysiwygHtml: Wysiwyg,
    WideImage: WideImage,
    Fact: Fact,
    MediaCluster: MediaCluster,
    CardHalf: Billboard,
    ResultBallsSmall: ResultBallsSmall,
    BrandBalls: BrandBalls,
    GifCard: GifCard,
    CardTextCta: CardTextCta,
    PromoVideos: PromoVideos,
    WideVideo: WideVideo,
    SmallVideo: SmallVideo,
    Quote: Quote,
    ImageGallery: ImageGallery,
    LinkList: LinkList,
    AlignedText: AlignedText,
    QuotesWithImage: QuotesWithImage,
    StatisticsText: StatisticsText,
    UniqueSellingPoints: UniqueSellingPoints,
    CardOffer: CardOffer,
    FloatingBrandBalls: FloatingBrandBalls,
};

const Streamfield: React.FC<StreamfieldProps> = ({ items = [], pageType }) => {
    if (!items.length) {
        return null;
    }

    const dynamicComponents = items.map((item, index) => {
        item.component = snakeToPascal(item.type);
        const Component = Components[item.component];

        if (!Component) {
            return null;
        }

        const classes = classNames(s.Root,
            item.component in s ? s[item.component] : '',
            item.type === "card_offer" ? s.Offer : '');

        return (
            <div key={index} className={classes} id={item.id}>
                <Component id={item.id} pageType={pageType} {...item.value} />
            </div>
        );
    });

    return <div>{dynamicComponents}</div>;
};

export default Streamfield;
